export default __webpack_public_path__ + "static/media/lentes-policia.1160a8bf.png";